import setMonth from "date-fns/fp/setMonth";
import setYear from "date-fns/fp/setYear";
import startOfMonth from "date-fns/fp/startOfMonth";
import { compose } from "lodash/fp";

const getStartOfMonth = (month: number, year: number) =>
  compose(setYear(year), setMonth(month), startOfMonth)(new Date(0));

export default getStartOfMonth;
